import React, { useEffect, useMemo } from "react";
import { prepareCompanyImageFolderName } from "../../../../../utils/Helpers";
import LoadingIndicator from "react-loading-indicator";
import { CloudUploadIcon } from "../../../../../Components/Icons";
import { DragArea } from "./UploadInput.styled";
import { useUploadInput } from "../../../../../hooks/useUploadInput";

const UploadInput = ({
  emitNewImageUpload,
  orgaId,
  companyId,
  emitIsUploading,
  isLogo = false
}) => {
  const { folderName } = useMemo(
    () => prepareCompanyImageFolderName(orgaId, companyId),
    [orgaId, companyId]
  );

  const cloudinaryContext = useMemo(() => {
    return `orgaId=${orgaId}|source=template-media-library|companyId=${companyId}`;
  }, [orgaId, companyId]);

  const { dragging, uploading, handleDragOver, handleDragLeave, handleDrop, handleInputChange } =
    useUploadInput({ cloudinaryContext, folderName, emitNewImageUpload, isLogo });

  useEffect(() => {
    emitIsUploading(uploading);
  }, [uploading, emitIsUploading]);

  if (uploading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <input
        disabled={uploading}
        id="upload-btn-campaign-creation-media-assets"
        type="file"
        onChange={handleInputChange}
        style={{ display: "none" }}
        multiple
      />
      <label
        htmlFor="upload-btn-campaign-creation-media-assets"
        style={{ cursor: "pointer", width: "100%" }}
      >
        <DragArea
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          dragging={dragging}
        >
          <CloudUploadIcon />
          Drag your files here or browse computer
        </DragArea>
      </label>
    </>
  );
};

export default UploadInput;
